import { ErrStyles } from './NotFoundPage'

export function ServerErrorState({ onRetry, eventId }: { onRetry: () => void; eventId?: string }) {
  const now = new Date()
  const stamp = new Intl.DateTimeFormat('ru-RU', {
    day: 'numeric', month: 'long',
    hour: '2-digit', minute: '2-digit',
  }).format(now)

  return (
    <div className="err-wrap">
      <div className="err">
        <div className="err-code danger">500</div>
        <div className="err-icon-line">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M10.3 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.7 3.86a2 2 0 0 0-3.4 0z" />
            <path d="M12 9v4M12 17v.01" />
          </svg>
          Что-то сломалось
        </div>
        <h1 className="err-title">
          Сервис <em>временно</em> не отвечает
        </h1>
        <p className="err-text">
          Мы уже знаем и&nbsp;чиним. Попробуйте обновить страницу через минуту. <b>Ваши данные в&nbsp;безопасности</b>, ничего не&nbsp;потерялось.
        </p>
        <div className="err-actions">
          <button className="err-btn err-btn-primary" onClick={onRetry}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 12a9 9 0 0 1 15-6.7L21 8M21 3v5h-5M21 12a9 9 0 0 1-15 6.7L3 16M3 21v-5h5" />
            </svg>
            Обновить
          </button>
          <a
            className="err-btn err-btn-ghost"
            href="https://max.ru/u/f9LHodD0cOJxyFsfUc55-mWzIyVtOnWwMlagPfClMqClINEKzphlsr_6FQY"
            target="_blank"
            rel="noopener noreferrer"
          >
            Сообщить в поддержку
          </a>
        </div>
        {eventId && (
          <div className="err-meta">
            err_id: {eventId.slice(0, 8)} · {stamp} МСК
          </div>
        )}
      </div>
      <ErrStyles />
    </div>
  )
}
